import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";

import Api from "src/Config";

import { useParams } from "react-router-dom";

export const FraudAlertDetailContext = createContext(null);

type Props = {
  children: ReactElement;
};

const FraudAlertDetailProvider: FunctionComponent<Props> = ({ children }) => {
  const { id, refId } = useParams();
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["fraud_alert_transaction_detail"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`tm/alerts/${id}`);

      return data;
    },
  });

  const {
    data: dataSTR,
    isLoading: isLoadingSTR,
    error: errorSTR,
    isFetching: isFetchingSTR,
  } = useQuery({
    queryKey: ["suspicious_transaction_report"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`tm/transactions/${refId}/str-report`);

      return data;
    },
  });

  const {
    mutateAsync,
    data: strData,
    isPending,
    error: strError,
  } = useMutation({
    mutationFn: async (payload: any) => {
      const data = await Api.post(`internal/extract-text-from-file`, payload);
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      isLoading,
      data,
      error,
      isFetching,
      dataSTR,
      isLoadingSTR,
      errorSTR,
      isFetchingSTR,
      mutateAsync,
      strData,
      isPending,
      strError,
    }),
    [
      isLoading,
      data,
      error,
      isFetching,
      dataSTR,
      isLoadingSTR,
      errorSTR,
      isFetchingSTR,
      mutateAsync,
      strData,
      isPending,
      strError,
    ],
  );
  return (
    <FraudAlertDetailContext.Provider value={contextValue}>
      {children}
    </FraudAlertDetailContext.Provider>
  );
};

export default FraudAlertDetailProvider;
